<template>
    <hr />

    <div class="footer-row" :class="{ 'single-button': !showChooseGuardian }">
        <button
            v-if="showChooseGuardian"
            class="btn btn-choose-guardian"
            type="button"
            @click="$emit('choose-guardian')"
        >
            Choose a Guardian
        </button>
        <button
            class="btn btn-light"
            type="button"
            @click="$emit('open-history')"
        >
            History
        </button>
    </div>
</template>

<script>
export default {
    name: 'PanelFooter',
    props: {
        showChooseGuardian: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['choose-guardian', 'open-history'],
};
</script>

<style scoped>
hr {
    margin-bottom: var(--space-3);
}

.footer-row {
    display: flex;
    justify-content: space-between;
    gap: var(--space-3);
}

.footer-row.single-button {
    justify-content: flex-start !important;
}

.footer-row.single-button .btn {
    margin-left: 0;
    margin-right: auto;
}

.btn-choose-guardian {
    border-radius: var(--Radius-radius-sm, 4px);
    border: var(--Stroke-stroke-1, 1px) solid
        var(--Colours-Neutral-600, #e6e6e6);
    background: var(--Colours-button-surface-white, #fff);
    color: var(--neutral-800);
}

.btn-choose-guardian:hover {
    background: var(--neutral-50);
    color: var(--neutral-800);
    border: var(--Stroke-stroke-1, 1px) solid
        var(--Colours-Neutral-600, #e6e6e6);
}
</style>
